module.exports = __webpack_public_path__ + "static/media/30.a9c67fcd.png";